import script from "./addMonitored.vue?vue&type=script&setup=true&lang=js"
export * from "./addMonitored.vue?vue&type=script&setup=true&lang=js"

import "./addMonitored.vue?vue&type=style&index=0&id=64dba1cf&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64dba1cf"]])

export default __exports__